import { Line } from "charts/templates/Line";
import data from "data/events/events_weekly_duration.csv";
import { ThemeColors } from "colors";

export function EventHoursPerWeek() {
  const tooltipOptions = function () {
    return `In the week of ${this.x}, The Warehouse provided ${this.y} hours of events.`;
  };

  const caption =
    "Source: <a href='https://thewarehouse.recdesk.com/Community/Calendar' target='_blank'>The Warehouse Calendar</a>";

  const moreOptions = {
    legend: { enabled: false },
  };

  return (
    <>
      <Line
        data={data}
        columns={[{ colName: "weekly_sum", color: ThemeColors.green }]}
        xAxisColumn="week_label"
        title="Total hours of events held per week at The Warehouse"
        caption={caption}
        tooltipOptions={tooltipOptions}
        moreOptions={moreOptions}
      />
    </>
  );
}
